var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sub-top" }, [
    _c("h4", { staticClass: "title" }, [
      _vm._v(" " + _vm._s(_vm.$t("detailComponent.LXXX")) + " "),
    ]),
    _c("div", { staticClass: "content-box" }, [
      _c("div", { staticClass: "content-left-box" }, [
        _c(
          "div",
          [
            _c("el-tag", { attrs: { size: "mini" } }, [
              _vm._v(" " + _vm._s(_vm.$t("detailComponent.LXSJ")) + " "),
            ]),
            _c("span", { staticClass: "text" }, [
              _vm._v(
                _vm._s(_vm.planDto.beginTime) +
                  " —— " +
                  _vm._s(_vm.planDto.endTime)
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("el-tag", { attrs: { size: "mini" } }, [
              _vm._v(" " + _vm._s(_vm.$t("detailComponent.LXMS")) + " "),
            ]),
            _c("span", { staticClass: "text" }, [
              _vm._v(
                _vm._s(
                  _vm.planDto.rule == 1
                    ? _vm.$t("detailComponent.XH")
                    : _vm.planDto.rule == 0
                    ? _vm.$t("detailComponent.DC")
                    : "--"
                ) + _vm._s(_vm.$t("detailComponent.LX"))
              ),
            ]),
            _vm._v(" "),
            _vm.prodIsFree
              ? _c("el-divider", { attrs: { direction: "vertical" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.prodIsFree
              ? _c("span", { staticClass: "text2" }, [
                  _vm._v(
                    _vm._s(_vm._f("filterScoreFlag")(_vm.planDto.scoreFlag))
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.prodIsFree
              ? _c("el-divider", { attrs: { direction: "vertical" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.prodIsFree
              ? _c("span", { staticClass: "text2" }, [
                  _vm._v(
                    _vm._s(_vm._f("filterAnswerFlag")(_vm.planDto.answerFlag))
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("el-tag", { attrs: { size: "mini" } }, [
              _vm._v(" " + _vm._s(_vm.$t("detailComponent.LXSJ1")) + " "),
            ]),
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.planDto.paperName)),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "cpbm" },
          [
            _c("el-tag", { attrs: { size: "mini" } }, [
              _vm._v(" " + _vm._s(_vm.$t("detailComponent.CPBM")) + " "),
            ]),
            _c("span", { ref: "textCpcode", staticClass: "text" }, [
              _vm._v(_vm._s(_vm.planDto.planId)),
            ]),
            _c("span", {
              staticClass: "text copy",
              attrs: { title: _vm.$t("detailComponent.FZCPBM") },
              on: { click: _vm.copyCpcode },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content-right-box" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.planDto.status == 1,
                expression: "planDto.status == 1 ",
              },
            ],
          },
          [
            _vm._m(0),
            _c("div", { staticClass: "text-box" }, [
              _c("div", { staticClass: "text-top" }, [
                _c("span", { staticClass: "font-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.lastingStatisDto && _vm.lastingStatisDto.initDataDto
                        ? _vm.lastingStatisDto.initDataDto.numerator
                        : ""
                    )
                  ),
                ]),
                _c("span", { staticClass: "total-font" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.lastingStatisDto && _vm.lastingStatisDto.initDataDto
                          ? _vm.lastingStatisDto.initDataDto.denominator
                          : ""
                      )
                  ),
                ]),
              ]),
              _c("span", { staticClass: "font-status" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (_vm.lastingStatisDto && _vm.lastingStatisDto.initDataDto
                        ? _vm.lastingStatisDto.initDataDto.numerator
                        : "1") ==
                        (_vm.lastingStatisDto &&
                        _vm.lastingStatisDto.initDataDto
                          ? _vm.lastingStatisDto.initDataDto.denominator
                          : "2")
                        ? _vm.$t("detailComponent.CSHWC")
                        : _vm.$t("detailComponent.CSHZ")
                    ) +
                    " "
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.planDto.status == 1,
                expression: "planDto.status == 1",
              },
            ],
          },
          [
            _vm._m(1),
            _c("div", { staticClass: "text-box" }, [
              _c("div", { staticClass: "text-top" }, [
                _c("span", { staticClass: "font-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.lastingStatisDto && _vm.lastingStatisDto.submitDataDto
                        ? _vm.lastingStatisDto.submitDataDto.numerator
                        : ""
                    )
                  ),
                ]),
                _c("span", { staticClass: "total-font" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.lastingStatisDto &&
                          _vm.lastingStatisDto.submitDataDto
                          ? _vm.lastingStatisDto.submitDataDto.denominator
                          : ""
                      )
                  ),
                ]),
              ]),
              _c("span", { staticClass: "font-status" }, [
                _vm._v(" " + _vm._s(_vm.$t("detailComponent.JJTD")) + " "),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.planDto.status == 1,
                expression: "planDto.status == 1",
              },
            ],
          },
          [
            _vm._m(2),
            _c("div", { staticClass: "text-box" }, [
              _c("div", { staticClass: "text-top" }, [
                _c("span", { staticClass: "font-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.lastingStatisDto && _vm.lastingStatisDto.waitDataDto
                        ? _vm.lastingStatisDto.waitDataDto.numerator
                        : ""
                    )
                  ),
                ]),
                _c("span", { staticClass: "total-font" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.lastingStatisDto && _vm.lastingStatisDto.waitDataDto
                          ? _vm.lastingStatisDto.waitDataDto.denominator
                          : ""
                      )
                  ),
                ]),
              ]),
              _c("span", { staticClass: "font-status" }, [
                _vm._v(" " + _vm._s(_vm.$t("detailComponent.KSTD")) + " "),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.planDto.status == 0,
                expression: "planDto.status == 0",
              },
            ],
          },
          [
            _vm._m(3),
            _c("div", { staticClass: "text-box" }, [
              _c("div", { staticClass: "text-top" }, [
                _c("span", { staticClass: "font-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.pendingStatisDto
                        ? _vm.pendingStatisDto.unReadyDataDto.numerator
                        : ""
                    )
                  ),
                ]),
                _c("span", { staticClass: "total-font" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.pendingStatisDto
                          ? _vm.pendingStatisDto.unReadyDataDto.denominator
                          : ""
                      )
                  ),
                ]),
              ]),
              _c("span", { staticClass: "font-status" }, [
                _vm._v(" " + _vm._s(_vm.$t("detailComponent.ZJZ")) + " "),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.planDto.status == 0,
                expression: "planDto.status == 0 ",
              },
            ],
          },
          [
            _vm._m(4),
            _c("div", { staticClass: "text-box" }, [
              _c("div", { staticClass: "text-top" }, [
                _c("span", { staticClass: "font-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.pendingStatisDto
                        ? _vm.pendingStatisDto.readyDataDto.numerator
                        : ""
                    )
                  ),
                ]),
                _c("span", { staticClass: "total-font" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.pendingStatisDto
                          ? _vm.pendingStatisDto.readyDataDto.denominator
                          : ""
                      )
                  ),
                ]),
              ]),
              _c("span", { staticClass: "font-status" }, [
                _vm._v(" " + _vm._s(_vm.$t("detailComponent.YJX")) + " "),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/chushihua.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/jiaojuan.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/startTeam.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/ing@2x.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/ok@2x.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }